import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

@Component({
  selector: 'rcp-nav-list-container',
  template: `
    <div class="nav-list__container" [class]="type()">
      <ng-content />
    </div>
  `,
  styleUrl: './nav-list-container.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class NavListContainerComponent {
  type = input.required<'primary' | 'secondary' | 'plain'>();

  collapsable = computed(() => this.type() === 'primary');
}
